<template>
  <div class="card hoverable">
    <div class="card-image" v-if="image_src">
      <img :src="image_src" :alt="content.title.rendered">
    </div>
    <div class="card-content">
      <router-link 
        :title="content.title.rendered"
        :to="{name:'article',params:{slug:content.slug}, query:{type:content.type}}" 
        class="card-title grey-text text-darken-4"
        v-html="content.title.rendered"></router-link>
        <div class="post-date">
          {{dateFormat(content.date, 'Do, MMM YYYY h:MM A')}}
        </div>
        <div class="card-excerpt" v-if="content.featured_media">
          {{content.excerpt.rendered | truncate(60)}}
        </div>
          <div class="card-excerpt" v-else>
          {{content.excerpt.rendered | truncate(160)}}
        </div>
    </div>
    <div class="card-action">
      <router-link
        class="btn-flat waves-effect blue-text text-accent-4"
        :to="{name:'article',params:{slug:content.slug}, query:{type:content.type}}">
        Read Full
      </router-link>
    </div>
  </div>
</template>
<script>
import {dateFormat} from '@/functions.js'
import {getImageById} from '@/services/mediaService.js'
export default {
  name:'PostCard',
  props:{
    content:{
      type:Object,
      required: true,
    }
  },
  data () {
    return {
      image_src:false,
    }
  },
  async mounted () {
    if(this.content.featured_media) {
    let {data} = await getImageById(this.content.featured_media)
    this.image_src = data.source_url
    }
  },
  methods:{
    dateFormat
  }
}
</script>
<style scoped lang="scss">
.card {
  height: calc(100% - 1.5rem);
  padding-bottom: 56px;
  .card-title {
    font-size: 20px;
    line-height: 22px;
    margin-bottom: 4px;
  }
  .card-image {
    border-radius: 4px 4px 0 0;
    overflow: hidden;
  }
  .post-date {
    font-size: 13px;
    margin-bottom: 8px;
  }
  .card-action {
    border-top: none;
    position: absolute;
    bottom:0;
    left:0;
    right:0;
    padding-top: 0px;
  }
  .card-excerpt {
    margin-top: 12px;
  }
}

</style>